import FloatingActionDropdown from 'emerald-ui/lib/FloatingActionDropdown';
import FloatingActionMenuItem from 'emerald-ui/lib/FloatingActionMenuItem';
import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs(
    [
      {
        component: FloatingActionDropdown,
        componentName: 'FloatingActionDropdown',
      },
    ],
    'FloatingActionDropdown'
  ),
  description: 'The FloatingActionDropdown displays a FloatingActionButton with a list of FloatingActionMenuItems.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FloatingActionDropdown, FloatingActionMenuItem, Icon },
      whiteBackground: true,
      code: `<FloatingActionDropdown tooltipsAtRight ariaLabel="Add item">
  <FloatingActionMenuItem title="Create">
    <Icon name="create" />
  </FloatingActionMenuItem>
  <FloatingActionMenuItem title="Done">
    <Icon name="done" />
  </FloatingActionMenuItem>
  <FloatingActionMenuItem title="Favorite">
    <Icon name="favorite" />
  </FloatingActionMenuItem>
</FloatingActionDropdown>`,
    },
  ],
};
